import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';
import { ILanguage } from 'src/models/general';

interface IProps {
  languages: ILanguage[];
  languageSelected: string;
  onChange: (newValue: ILanguage | null) => void;
}

const LanguageAutocomplete = ({
  languages,
  languageSelected,
  onChange
}: IProps) => {
  const languageOptions: ILanguage[] = useMemo(
    () => [{ name: 'All Language', language: 'all-language' }, ...languages],
    [languages]
  );

  const selectedLanguage = useMemo(
    () =>
      languageOptions.find((lang) => lang.language === languageSelected) ||
      null,
    [languageOptions, languageSelected]
  );

  return (
    <Autocomplete
      disableClearable
      size="small"
      sx={{
        minWidth: 155,
        width: { xs: '100%', md: 155 },
        '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
          backgroundColor: '#FFFFFF'
        }
      }}
      options={languageOptions}
      getOptionLabel={(option: ILanguage) => option.name}
      value={selectedLanguage}
      onChange={(_, newValue: ILanguage | null) => {
        onChange(newValue);
      }}
      renderInput={(params) => <TextField {...params} />}
    />
  );
};

export default LanguageAutocomplete;
